import Vue from 'vue'

import AppLayout from './layout/index.vue'
import router from './router'
import store from './store'
import './mixins'
import './thirdParty'
import './vue-component'
import './vue-filter'
import './assets/css/vendors.min.css'
import './assets/css/style.css'
import './assets/css/style-base.css'
import './assets/css/style_other.css'
import './assets/css/style_custom.css'
import './assets/css/style_content.css'
import './assets/css/tree.css'
import './assets/css/select2.css'
import './assets/css/responsive.css'
import '@/assets/global.css'
import 'viewerjs/dist/viewer.css'
import './assets/css/toast.css'
import VueViewer from 'v-viewer'
import VueSSE from 'vue-sse';
import * as Sentry from "@sentry/vue";
import Clarity from '@microsoft/clarity';

Vue.use(VueViewer)
Vue.use(VueSSE);
VueViewer.setDefaults({
  zoomRatio: 0.2,
  minZoomRatio: 0.3
})

Sentry.init({
  Vue,
  dsn: "https://fbbb45740f497252f092493e3cdefb68@o4507530151591936.ingest.de.sentry.io/4507530154737744",
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  // Performance Monitoring
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  // tracePropagationTargets: ["localhost", /^https:\/\/my\.nextpay\.global/, /^https:\/\/my\.nextpay\.vn/],
  tracePropagationTargets: [/^https:\/\/my\.nextpay\.global/, /^https:\/\/my\.nextpay\.vn/],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

Clarity.init(process.env.VUE_CLARITY_PROJECTID);

router.afterEach(() => {
  app.loading = false
})

const app = new Vue({
  name: 'Root',
  data: { loading: true },
  router,
  store,
  async created() {
    store.commit('dom/SET_WINDOW_WIDTH', window.innerWidth)
    window.addEventListener('resize', () => store.commit('dom/SET_WINDOW_WIDTH', window.innerWidth))
    window.addEventListener('storage', function (e) {
      if (e.isTrusted && (e.key === 'token' || e.key === 'userData')) {
        location.reload()
      }
    })
  },

  beforeDestroy() {
    window.removeEventListener('resize', () => store.commit('dom/SE_TWINDOW_WIDTH', window.innerWidth))
  },
  render: h => h(AppLayout)
}).$mount('#app')
